import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const PreConsultation = () => {
  const [bookingId, setBookingId] = React.useState("");
  const [, setData] = React.useState(null);
  const [draft, setDraft] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const load = async () => {
    if (!bookingId.trim()) return;
    setLoading(true);
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/bookings/${bookingId}/pre-consultation`
      );
      setData(json);
      setDraft(typeof json === "object" ? JSON.stringify(json, null, 2) : (json || ""));
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const save = async () => {
    if (!bookingId.trim() || !draft.trim()) return;
    let body;
    try {
      body = JSON.parse(draft);
    } catch (_) {
      body = { content: draft };
    }
    try {
      await httpClient(`${API_BASE_URL}/bookings/${bookingId}/pre-consultation`, {
        method: "PUT",
        body: JSON.stringify(body),
      });
      notify("Formulaire pré-consultation enregistré", { type: "success" });
      load();
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <AssignmentIcon /> Formulaire de pré-consultation
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Consulter et modifier le formulaire de pré-consultation d'un rendez-vous.
      </Alert>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField size="small" label="ID booking"
                value={bookingId} onChange={(e) => setBookingId(e.target.value)} />
              <Button variant="contained" onClick={load}
                disabled={loading || !bookingId.trim()}>
                {loading ? <CircularProgress size={18} /> : "Charger"}
              </Button>
            </Box>
            <TextField multiline minRows={10} fullWidth label="Contenu (JSON)"
              value={draft} onChange={(e) => setDraft(e.target.value)} />
            <Box>
              <Button variant="outlined" onClick={save}
                disabled={!bookingId.trim() || !draft.trim()}>
                Enregistrer
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: PreConsultation };
